// Add all JS development here
jQuery(function ($) {
  $(document).ready(function () {
    // Hide Offcanvace when click nav link
    $("#mobileMenu a.nav-link").on("click", function () {
      $("#mobileMenu").offcanvas("hide");
    });

    //Add Fixed Nav bar function
    var previousScroll = 0;
    var navBar = $("#navigation-scroll");

    $(window).scroll(function () {
      var currentScroll = $(this).scrollTop();

      if (currentScroll > 100 && currentScroll > previousScroll) {
        hideNav();
      } else {
        showNav();
      }

      previousScroll = currentScroll;
    });

    function hideNav() {
      navBar.addClass("is-hidden");
    }

    function showNav() {
      navBar.removeClass("is-hidden");
    }

    // Hide the video element initially
    $("#homefirstVideo").hide();
    $("#homeSecondVideo").hide();
    $("#homeThirdVideo").hide();

    // First video
    $(".thumbnail").click(function () {
      $(".thumbnail").fadeOut(70, function () {
        $("#homefirstVideo").fadeIn(70);
        $("#homefirstVideo")[0].play();
      });
    });

    $("#homefirstVideo").click(function () {
      $(this).fadeOut(70, function () {
        $(".thumbnail").fadeIn(70);
        $(this)[0].pause();
      });
    });

    // Second video
    $(".second-thumbnail").click(function () {
      $(".second-thumbnail").fadeOut(70, function () {
        $("#homeSecondVideo").fadeIn(70);
        $("#homeSecondVideo")[0].play();
      });
    });

    $("#homeSecondVideo").click(function () {
      $(this).fadeOut(70, function () {
        $(".second-thumbnail").fadeIn(70);
        $(this)[0].pause();
      });
    });

    // Third video
    $(".third-thumbnail").click(function () {
      $(".third-thumbnail").fadeOut(70, function () {
        $("#homeThirdVideo").fadeIn(70);
        $("#homeThirdVideo")[0].play();
      });
    });

    $("#homeThirdVideo").click(function () {
      $(this).fadeOut(70, function () {
        $(".third-thumbnail").fadeIn(70);
        $(this)[0].pause();
      });
    });

    // Function to initialize and control a carousel

    // --------- If mouse over then pause transision ---------
    // --------- If mouse over then pause transision ---------
    //   function initializeCarousel($carousel) {
    //     var $images = $carousel.find(".product-img");
    //     var currentIndex = 0;
    //     var intervalId;

    //     function showNextImage() {
    //         $($images[currentIndex]).css("opacity", 0);
    //         currentIndex = (currentIndex + 1) % $images.length;
    //         $($images[currentIndex]).css("opacity", 1);
    //     }

    //     // Initial transition to the first image
    //     showNextImage();

    //     function startInterval() {
    //         intervalId = setInterval(showNextImage, 2200);
    //     }

    //     startInterval();

    //     $carousel.on("mouseenter", function() {
    //         clearInterval(intervalId);
    //     });
    //     $carousel.on("mouseleave", function() {
    //         startInterval();
    //     });
    // }

    // Initialize each carousel separately
    // $(".images-wrap").each(function() {
    //     initializeCarousel($(this));
    // });
    // --------- End If mouse over then pause transision ---------
    // --------- End If mouse over then pause transision ---------

    // --------- Not mouse over remove effect ---------
    // --------- Not mouse over remove effect ---------
    // Function to initialize and control a carousel
    function initializeCarousel($carousel) {
      var $images = $carousel.find(".product-img");
      var currentIndex = 0; // Current image index

      function showNextImage() {
        $($images[currentIndex]).css("opacity", 0);
        currentIndex = (currentIndex + 1) % $images.length;
        $($images[currentIndex]).css("opacity", 1);
      }
      showNextImage();
      setInterval(showNextImage, 2200); // 3 seconds
    }

    // Initialize each carousel separately
    $(".images-wrap").each(function () {
      initializeCarousel($(this));
    });

    // --------- End Not mouse over remove effect ---------
    // --------- End Not mouse over remove effect ---------

    // Visibility floating element
    function handleFloatingElement(entries, observer) {
      entries.forEach((entry) => {
        const floatingElement = document.getElementById("floating-aria");
        if (entry.isIntersecting) {
          floatingElement.style.transform = "translateY(180%)";
        } else {
          floatingElement.style.transform = "translateY(0)";
        }
      });
    }
    // Create an Intersection Observer
    const observer = new IntersectionObserver(handleFloatingElement, {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    });
    // Observe the footer element
    const footer = document.getElementById("footer");
    if (footer) {
      observer.observe(footer);
    }
    // End Visibility floating element

    // Add if user scroll down then video pause function
    // Add if user scroll down then video pause function
     // Get all elements with the class "thumb-video"
  var videos = document.getElementsByClassName("thumb-video");

  // Options for the Intersection Observer
  var options = {
    root: null, // Use the viewport as the root
    rootMargin: '0px', // No margin
    threshold: 0.5 // Trigger when at least 50% of the video is visible
  };

  // Function to handle the intersection change for each video
  function handleIntersection(entries, observer) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        // Video is in the viewport, so play it
        entry.target.play();
        // Hide the associated thumbnail image
        var thumbnailClass = $(entry.target).data("thumbnail-class");
        $("." + thumbnailClass).fadeOut(70);
      } else {
        // Video is out of the viewport, so pause it
        entry.target.pause();
        // Show the associated thumbnail image
        var thumbnailClass = $(entry.target).data("thumbnail-class");
        $("." + thumbnailClass).fadeIn(70);
      }
    });
  }

  // Create an Intersection Observer for each video element
  for (var i = 0; i < videos.length; i++) {
    var observer1 = new IntersectionObserver(handleIntersection, options);
    observer1.observe(videos[i]);
  }

    //End  Add if user scroll down then video pause function
    //End  Add if user scroll down then video pause function

    //Hero Slider
    $(".products-slider .slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".slider-nav",
      infinite: true, // Enable loop
      // autoplay: true, // Enable automatic sliding
      autoplaySpeed: 6000, // Set the interval in milliseconds (e.g., 3000ms = 3 seconds)
    });

    $(".products-slider .slider-nav").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: true,
      infinite: true,
      asNavFor: ".slider-for",
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      prevArrow: '<button type="button" class="slick-prev"></button>', // Customize previous arrow
      nextArrow: '<button type="button" class="slick-next"></button>', // Customize next arrow
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  });
});
